import React from 'react';
import makeStyles from "@material-ui/core/styles/makeStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import DataService from "../../../../../../src/Service";
import CloseIcon from "@material-ui/icons/Close";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import CustomInput from '../../../../../Components/CustomInput';
import { withStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import FormControl from '@material-ui/core/FormControl';
import Divider from '@material-ui/core/Divider';
import CustomSelect from "../../../../../Components/CustomSelect";

const useStyles = makeStyles((theme) => ({
    formWrapper: {
        background: "#fff",
        // width: "400px",
        padding: theme.spacing(3),
    },
    title: {
        textTransform: "capitalize",
    },
    dialog_title: {
        "& h6": {
            fontWeight: "700"
        }
    }
}));

const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const PriceSummaryModal = (props) => {
    let { isOpen, onModalClose, currentSelection, selectedValue, priceSummaryFlag, onChangeInputValue, setPriceSummaryModal, inputValue, onChangeSelectedValue, rateCardInfo, setElementPrice, handleSubmit, addonData, coachingPrice } = props;
    const classes = useStyles();
    const rateCardType = ['Programme Price', 'Session Rate', 'Hourly Rate'];

    return (
        <div>
            <Dialog
                fullWidth={true}
                maxWidth={"sm"}
                open={isOpen}
                onClose={onModalClose}
            >
                <DialogTitle
                    id="customized-dialog-title"
                >
                    Edit Price
                </DialogTitle>
                <Divider />

                <DialogContent>
                    <div className={classes.formWrapper}>
                        {/*<form>*/}
                        {/* {priceSummaryFlag.text === 'totalProgramPrice' ? */}
                        <div>
                            <Grid container spacing={1} alignItems={"center"} justify={"flex-start"}
                                style={{ marginBottom: 10 }}>
                                <Grid item xs={2}>
                                    <Typography variant="subtitle2" className={classes.title}>Price 1</Typography>
                                </Grid>
                                <Grid item xs={9}>
                                    {priceSummaryFlag.text === 'totalProgramPrice' ?
                                        <CustomInput
                                            placeholder="Price"
                                            variant="outlined"
                                            id="tempPrice"
                                            name={'summary_price'}
                                            type='number'
                                            parentcall={(value, name) => {
                                                onChangeInputValue(value, name, priceSummaryFlag.id, "addOn")
                                            }}
                                            min="0"
                                            value={addonData[priceSummaryFlag.id]?.tempPrice}
                                            InputLabelProps={{ shrink: true }} />
                                        :
                                        <CustomInput
                                            placeholder="Price"
                                            variant="outlined"
                                            id="price"
                                            name={'price'}
                                            type='number'
                                            min="0"
                                            parentcall={(value, name) => {
                                                onChangeInputValue(value, name, priceSummaryFlag.id, "primary")
                                            }}
                                            value={coachingPrice}
                                            InputLabelProps={{ shrink: true }} />
                                    }
                                </Grid>
                            </Grid>
                        </div>
                        <div>
                            <Grid container alignItems={"center"} justify={"flex-end"}
                                style={{ marginTop: 20 }}>
                                <Grid item xs={2}>
                                    <Button disableElevation variant="contained" type="submit"
                                        style={{ textTransform: 'capitalize' }}
                                        onClick={onModalClose}>Cancel</Button>
                                </Grid>
                                <Grid item xs={1}>
                                    <Button type='submit' variant="contained" style={{ textTransform: 'capitalize' }}
                                        color="primary" onClick={() => handleSubmit(priceSummaryFlag.id,)} color="primary">
                                        Save
                                    </Button>
                                </Grid>
                            </Grid>
                        </div>

                        {/*</form>*/}
                    </div>
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default PriceSummaryModal
